import gsap from 'gsap';

const doModal = {
  isSlideout: (modal) => {
    return modal && modal.classList.contains('slideout');
  },
  isSlideup: (modal) => {
    return modal && modal.classList.contains('slideup');
  },
  setModal: (id) => {
    if (id) {
      const modal = document.getElementById(id);
      if (modal) {
        document.querySelector('.blocker').style.display = 'flex';

        document.body.style.overflow = 'hidden';

        modal.classList.add('active');
        modal.setAttribute('aria-hidden', 'false');

        gsap.set('.blocker', {
          opacity: '1',
        });

        if (doModal.isSlideout(modal)) {
          document.querySelector('.blocker').style.backgroundColor = 'transparent';
        } else {
          document.querySelector('.blocker').style.backgroundColor = '';
        }

        if (doModal.isSlideout(modal)) {
          gsap.set(modal, {
            width: 0,
          });
        }
        if (doModal.isSlideup(modal)) {
          gsap.set(modal, {
            y: '100%',
          });
        }
      }
    }
  },
  openModal: (id) => {
    if (id) {
      const modal = document.getElementById(id);
      if (modal) {
        document.querySelector('.blocker').style.display = 'flex';

        document.body.style.overflow = 'hidden';

        modal.classList.add('active');
        modal.setAttribute('aria-hidden', 'false');


        if (doModal.isSlideout(modal)) {
          document.querySelector('.blocker').style.backgroundColor = 'transparent';
        } else {
          document.querySelector('.blocker').style.backgroundColor = '';
        }

        if (doModal.isSlideout(modal)) {
          gsap.set(modal, {
            width: 0,
          });
          gsap.to(modal, {
            width: 'auto',
            duration: 0.3,
            ease: 'power2.out',
          });
          gsap.to('.blocker', {
            opacity: 1,
            duration: 0.2,
            ease: 'ease.inOut',
          });
        } else if (doModal.isSlideup(modal)) {
          gsap.set(modal, { y: '100%' });
          gsap.to(modal, {
            y: 0,
            duration: 0.3,
            ease: 'power2.out',
          });
          gsap.to('.blocker', {
            opacity: 1,
            duration: 0.2,
            ease: 'ease.inOut',
          });
        } else {
          gsap.to('.blocker', {
            opacity: 1,
            duration: 0.2,
            ease: 'ease.inOut',
          });
        }

      }
    }
  },
  closeModal: () => {
    const modal = document.querySelector('.modal.active');

    if (modal) {
      if (doModal.isSlideout(modal)) {
        gsap.to(modal, {
          width: 0,
          duration: 0.3,
          ease: 'power2.in',
          onComplete: () => {
            modal.classList.remove('active');
            modal.setAttribute('aria-hidden', 'true');
            document.querySelector('.blocker').style.display = 'none';
            document.body.style.overflow = '';
          },
        });
        gsap.to('.blocker', {
          // opacity: 0,
          duration: 0.3,
          ease: 'ease.inOut',
        });
      } else if (doModal.isSlideup(modal)) {
        gsap.to(modal, {
          y: '100%',
          duration: 0.3,
          ease: 'power2.in',
          onComplete: () => {
            modal.classList.remove('active');
            modal.setAttribute('aria-hidden', 'true');
            document.querySelector('.blocker').style.display = 'none';
            document.body.style.overflow = '';
          },
        });
        gsap.to('.blocker', {
          opacity: 0,
          duration: 0.3,
          ease: 'ease.inOut',
        });
      } else {
        gsap.to('.blocker', {
          opacity: 0,
          duration: 0.2,
          ease: 'ease.inOut',
          onComplete: () => {
            modal.classList.remove('active');
            modal.setAttribute('aria-hidden', 'true');
            document.querySelector('.blocker').style.display = 'none';
            document.body.style.overflow = '';
          },
        });
      }
    }
  },
  init: () => {
    const opens = document.querySelectorAll('.modal-open a, a.modal-open');
    if (!opens || opens.length === 0) return;

    for (var i = 0; i < opens.length; i++) {
      let open = opens[i];

      open.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        var href = event.target.getAttribute('href');
        var id = href ? href.replace('#', '') : null;

        if (id) {
          doModal.openModal(id);
        }
        
        return false;
      });
    }

    const closes = document.querySelectorAll('.modal-close');

    for (var i = 0; i < closes.length; i++) {
      let close = closes[i];

      close.addEventListener('click', () => {
        doModal.closeModal();
      });
    }

    document.addEventListener('click', (event) => {
      const close = event.target.closest('.modal-close');
      if (!close) return;
      doModal.closeModal();
    });

    const blocker = document.querySelector('.blocker');
    if (blocker) {
      blocker.addEventListener('click', (event) => {
        const activeModal = blocker.querySelector('.modal.active');
        if (!activeModal) return;
        if (event.target.closest('.modal-inner')) return;
        doModal.closeModal();
      });
    }

    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        doModal.closeModal();
      }
    });
  },
};

export default doModal;
